'use strict';

export default class UpdateListController {
  errors = {
    other: undefined
  };
  message = '';
  submitted = false;

  year = new Date().getFullYear();
  yearsToList = 2;
  years = [];

  /*@ngInject*/
  constructor(Updates, list, $sce, marked, $state) {
    console.log(list);
    this.list = list;
    this._$sce = $sce;
    this._$state = $state;
    this._$marked = marked;
    this._Updates = Updates;
    // this._Updates = Updates;
    // console.log(today);
    // this.todayUpdate = today.data;
    // this.today = new Date();
    //
    // // Key for days (numerical) to string 0 => Sunday, etc.
    // this.dayKey = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  }

  updateMarkdown(input) {
    let renderedHTML = '';
    if(input) {
      renderedHTML = this._$sce.trustAsHtml(this._$marked(input));
    }
    return renderedHTML;
  }

  deleteUpdate(update) {
    console.log(update);
    this._Updates.delete(update._id)
        .then(res => {
          console.log('Result', res);
          console.log(update);
          this.list.splice(this.list.indexOf(update), 1);
        })
        .catch(err => {
          console.log('Error', err);
        });
  }

}



// WEBPACK FOOTER //
// ./client/app/update/list/list.controller.js